// import React, { useState, useCallback, useEffect } from "react";
// import { IoMdAdd } from "react-icons/io";
// import { IoHeartOutline, IoHeartSharp, IoCloseSharp } from "react-icons/io5";
// import { BASE_URL, USER_URL } from "../../../constant/api";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import { useSession } from "../../../ApiCalls/useSession";
// import AddToCartModel from "../AddToCartModel/AddToCartModel";
// import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

// function ProductCard({ products = [], title, bg,view_all_url }) {
//   useSession()
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [quantity, setQuantity] = useState(1);
//   const [wishlist, setWishlist] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const openModal = useCallback((product) => {
//     setSelectedProduct(product);
//     setIsModalOpen(true);
//   }, []);

//   const closeModal = useCallback(() => {
//     setIsModalOpen(false);
//     setSelectedProduct(null);
//   }, []);

//   useEffect(() => {
//     const getWishlist = async () => {
//       const token = localStorage.getItem("token");
//       const sessionId = localStorage.getItem("sessionid");
//       const headers = token
//         ? { Authorization: `Token ${token}` }
//         : { "Session-Id": sessionId };
//       // console.log(headers);

//       try {
//         const response = await USER_URL.get(`/products/wishlist/`, {
//           // headers,
//         });
//         setWishlist(response.data.items.map((item) => item.product_id));
//         // console.log(response)
//       } catch (error) {
//         console.error("Error fetching wishlist:", error);
//       }
//     };

//     getWishlist();
//   }, []);

//   // Toggle Wishlist
//   const toggleWishlist = async (product_id) => {
//     try {
//       const isWishlisted = wishlist.includes(product_id);
//       const token = localStorage.getItem("token");
//       const sessionId = localStorage.getItem("sessionid");
//       const headers = token
//         ? { Authorization: `Token ${token}` }
//         : { "Session-Id": sessionId };
//       // console.log(headers);

//       const res = await USER_URL.post(
//         `/products/wishlist/`,
//         { product_id },
//         // { headers }
//       );

//       console.log(res);

//       setWishlist((prev) =>
//         isWishlisted
//           ? prev.filter((id) => id !== product_id)
//           : [...prev, product_id]
//       );
//     } catch (error) {
//       console.error("Error toggling wishlist:", error);
//     }
//   };

//   const handleDeleteWishlistItem = async (productId) => {
//     const token = localStorage.getItem("token");
//     let sessionId = localStorage.getItem("sessionid");

//     const headers = token
//       ? { Authorization: `Token ${token}` }
//       : { "Session-Id": sessionId };

//     // console.log(headers);

//     try {
//       const response = await USER_URL.delete(`/products/wishlist/${productId}/`);

//       if (response.data.Status === "1") {
//         // Assuming `wishlist` is a state variable
//         setWishlist((prev) => prev.filter((id) => id !== productId));
//         console.log("Item deleted successfully:", response.data);
//       } else {
//         console.error("Unexpected response:", response.data);
//       }
//     } catch (error) {
//       console.error(`Error deleting item ${productId}:`, error);
//     }
//   };

//       // Function to render the stars
//       const totalStars = 5;
//       const renderStars = (rating) => {
//           const filledStars = Math.floor(rating); // Number of full stars
//           const hasHalfStar = rating % 1 >= 0.5; // For half stars
//           const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0); // Empty stars

//           return (
//               <div className="flex justify-center items-center">
//                   {/* Render Filled Stars */}
//                   {[...Array(filledStars)].map((_, index) => (
//                       <FaStar key={`filled-${index}`} className="text-yellow-500" />
//                   ))}

//                   {/* Render Half Star */}
//                   {hasHalfStar && <FaStarHalfAlt key="half-star" className="text-yellow-500" />}

//                   {/* Render Empty Stars */}
//                   {[...Array(emptyStars)].map((_, index) => (
//                       <FaRegStar key={`empty-${index}`} className="text-gray-400" />
//                   ))}
//               </div>
//           );
//       };
//   return (
//     <div style={{ backgroundColor: bg }} className="my-2  pt-5">
//       <div className='flex justify-between items-center px-5'>
//         <h2 className="text-2xl md:text-3xl font-semibold mb-4">{title}</h2>
//         <p className='text-xl text-brand-text-light hover:text-brand-primary transition duration-500 ease-in-out'>

//           <Link to={view_all_url}>
//             view all
//           </Link>
//         </p>
//       </div>
//       <div className="flex space-x-4 overflow-x-auto p-4">
//         {products.length > 0 ? (
//           products.map((product) => (
//             <div
//               key={product.id}
//               className="w-48 md:w-60  flex-none rounded-lg bg-white p-3 border-2 border-gray-300 shadow-md"
//             >
//               <div className="flex justify-between items-center text-sm text-brand-light-gray ">
//                 <span className="rounded-lg bg-red-600 p-1">
//                   {product.offer_percent ? `-${product.offer_percent}%` : ""}
//                 </span>
//                 <span
//                   className="text-red-700 text-2xl cursor-pointer"
//                   onClick={() =>
//                     wishlist.includes(product.id)
//                       ? handleDeleteWishlistItem(product.id) // Call delete function if the product is in the wishlist
//                       : toggleWishlist(product.id) // Call toggle function to add the product to the wishlist
//                   }
//                 >
//                   {wishlist.includes(product.id) ? (

//                     <IoHeartSharp /> // Filled heart for items in the wishlist
//                   ) : (
//                     <IoHeartOutline /> // Outline heart for items not in the wishlist
//                   )}
//                 </span>

//               </div>
//               <Link to={title === "Offer Products" ? `/offers/${product.offer_id}` : `/product-details/${product.id}`}>
//                 <img
//                   src={
//                     product.product_images?.[0]?.image
//                       ? product.product_images[0].image.startsWith(BASE_URL)
//                         ? product.product_images[0].image
//                         : `${BASE_URL}${product.product_images[0].image}`
//                       : "/images/default-product.png"
//                   }
//                   alt={product.name || "Product"}
//                   className="mb-2 h-32 w-full object-contain my-2 transition transform hover:scale-105"
//                   onError={(e) => {
//                     e.target.src = "/images/default-product.png";
//                   }}
//                 />
//               </Link>

//               <div className="flex flex-col items-start gap-2">
//                 <h3 className="font-semibold">
//                   <Link to={title === "Offer Products" ? `/offers/${product.offer_id}` : `/product-details/${product.id}`}>
//                     {product.name || "No Name Available"}
//                   </Link>
//                 </h3>
//                 <p className="line-clamp-1 text-sm text-gray-600">
//                   {product.description || "No description available"}
//                 </p>
//                 <div className="flex flex-col justify-center items-start gap-1 text-xs md:text-sm">
//                   {renderStars(product.product_rating)}
//                   <span className="text-center text-gray-500">{product.product_rating} ({product.product_review_count} Reviews)</span>
//                 </div>
//                 <div className="flex justify-between w-full">
//                   <p className="text-lg font-bold">
//                     {product.price ? ` ₹${product.price}` : "N/A"}
//                   </p>
//                   <span
//                     className="rounded-md bg-brand-primary py-1 px-2 text-white cursor-pointer"
//                     onClick={() => openModal(product)}
//                   >
//                     ADD
//                   </span>
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <p className="text-center text-gray-500">No products available.</p>
//         )}
//       </div>
//       <AddToCartModel
//         selectedProduct={selectedProduct}
//         isModalOpen={isModalOpen}
//         closeModal={closeModal}
//       />
//     </div>
//   );
// }

// export default ProductCard;

import React, { useState, useRef, useEffect, useCallback } from "react";
import { IoMdAdd } from "react-icons/io";
import { IoHeartOutline, IoHeartSharp, IoCloseSharp } from "react-icons/io5";
import { BASE_URL, USER_URL } from "../../../constant/api";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useSession } from "../../../ApiCalls/useSession";
import AddToCartModel from "../AddToCartModel/AddToCartModel";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

function ProductCard({ products = [], title, bg, view_all_url }) {
  useSession();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showViewAll, setShowViewAll] = useState(false);
  const containerRef = useRef(null);
  const navigate = useNavigate();

  // Check for overflow
  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        const container = containerRef.current;
        const isOverflowing = container.scrollWidth > container.clientWidth;
        setShowViewAll(isOverflowing);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [products]); // Re-check when products change

  const openModal = useCallback((product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  }, []);

  useEffect(() => {
    const getWishlist = async () => {
      const token = localStorage.getItem("token");
      const sessionId = localStorage.getItem("sessionid");
      const headers = token
        ? { Authorization: `Token ${token}` }
        : { "Session-Id": sessionId };

      try {
        const response = await USER_URL.get(`/products/wishlist/`, {
          // headers,
        });
        setWishlist(response.data.items.map((item) => item.product_id));
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      }
    };

    getWishlist();
  }, []);

  const toggleWishlist = async (product_id) => {
    try {
      const isWishlisted = wishlist.includes(product_id);
      const token = localStorage.getItem("token");
      const sessionId = localStorage.getItem("sessionid");
      const headers = token
        ? { Authorization: `Token ${token}` }
        : { "Session-Id": sessionId };

      const res = await USER_URL.post(
        `/products/wishlist/`,
        { product_id },
        // { headers }
      );

      setWishlist((prev) =>
        isWishlisted
          ? prev.filter((id) => id !== product_id)
          : [...prev, product_id],
      );
    } catch (error) {
      console.error("Error toggling wishlist:", error);
    }
  };

  const handleDeleteWishlistItem = async (productId) => {
    const token = localStorage.getItem("token");
    let sessionId = localStorage.getItem("sessionid");

    const headers = token
      ? { Authorization: `Token ${token}` }
      : { "Session-Id": sessionId };

    try {
      const response = await USER_URL.delete(
        `/products/wishlist/${productId}/`,
      );
      if (response.data.Status === "1") {
        setWishlist((prev) => prev.filter((id) => id !== productId));
      }
    } catch (error) {
      console.error(`Error deleting item ${productId}:`, error);
    }
  };

  const totalStars = 5;
  const renderStars = (rating) => {
    const filledStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = totalStars - filledStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="flex items-center justify-center">
        {[...Array(filledStars)].map((_, index) => (
          <FaStar key={`filled-${index}`} className="text-yellow-500" />
        ))}
        {hasHalfStar && (
          <FaStarHalfAlt key="half-star" className="text-yellow-500" />
        )}
        {[...Array(emptyStars)].map((_, index) => (
          <FaRegStar key={`empty-${index}`} className="text-gray-400" />
        ))}
      </div>
    );
  };

  return (
    <div style={{ backgroundColor: bg }} className="my-2 pt-5">
      <div className="flex items-center justify-between px-5">
        <h2 className="mb-4 text-2xl font-semibold md:text-3xl">{title}</h2>
        {/* {showViewAll && (
          <p className="text-xl text-brand-text-light transition duration-500 ease-in-out hover:text-brand-primary">
            <Link to={view_all_url}>View All</Link>
          </p>
        )} */}
      </div>
      <div ref={containerRef} className="flex space-x-4 overflow-x-auto p-4">
        {products.length > 0 ? (
          products.map((product) => (
            <div
              key={product.id}
              className="w-48 flex-none rounded-lg border-2 hover:scale-105 transition-transform ease-in-out duration-300 border-gray-300 bg-white p-3 shadow-md md:w-60"
            >
              <div className="flex items-center justify-between text-sm text-brand-light-gray">
                {product.offer_percent && (
                  <span className="rounded-lg bg-red-600 p-1 px-2">
                    {product.offer_percent ? `-${product.offer_percent}%` : ""}
                  </span>
                )}
                <span
                  className="cursor-pointer text-2xl text-red-700"
                  onClick={() =>
                    wishlist.includes(product.id)
                      ? handleDeleteWishlistItem(product.id)
                      : toggleWishlist(product.id)
                  }
                >
                  {wishlist.includes(product.id) ? (
                    <IoHeartSharp />
                  ) : (
                    <IoHeartOutline />
                  )}
                </span>
              </div>
              <Link
                to={
                  title === "Offer Products"
                    ? `/offers/${product.offer_id}`
                    : `/product-details/${product.id}`
                }
              >
                <img
                  src={
                    product.product_images?.[0]?.image
                      ? product.product_images[0].image.startsWith(BASE_URL)
                        ? product.product_images[0].image
                        : `${BASE_URL}${product.product_images[0].image}`
                      : "/images/default-product.png"
                  }
                  alt={product.name || "Product"}
                  className="my-2 mb-2 h-32 w-full transform object-contain transition"
                  onError={(e) => {
                    e.target.src = "/images/default-product.png";
                  }}
                />
              </Link>
              <div className="flex flex-1  flex-col items-start justify-between gap-2">
                <h3 className="font-semibold hover:text-green-500">
                  <Link
                    to={
                      title === "Offer Products"
                        ? `/offers/${product.offer_id}`
                        : `/product-details/${product.id}`
                    }
                  >
                    {product.name || "No Name Available"}
                  </Link>
                </h3>
                <p className="line-clamp-1 text-sm text-gray-600">
                  {product.description || "No description available"}
                </p>
                <div className="flex flex-col items-start justify-center gap-1 text-xs md:text-sm">
                  {renderStars(product.product_rating)}
                  <span className="text-center text-gray-500">
                    {product.product_rating} ({product.product_review_count}{" "}
                    Reviews)
                  </span>
                </div>
                <div className="flex w-full justify-between">
                  <p className="text-lg font-bold">
                    {product.price ? ` ${product.currency_symbol}${product.price}` : "N/A"}
                  </p>
                  <span
                    className="cursor-pointer rounded-md bg-brand-primary px-2 py-1 text-white"
                    onClick={() => openModal(product)}
                  >
                    ADD
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500">No products available.</p>
        )}
      </div>
      <AddToCartModel
        selectedProduct={selectedProduct}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
      />
    </div>
  );
}

export default ProductCard;
